import { Component, OnInit } from '@angular/core';
import { ContactsService } from '../../shared/services/contacts.service';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { RevertCallFinishTypeSnapshotAction, RevertEditedFilterChanges } from '../../../contacts/contacts.actions';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'cc-filters-layer',
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          opacity: 1,
          bottom: '-5px',
          left: '30%'
        })
      ),
      state(
        'closed',
        style({
          opacity: 0,
          bottom: '-55px',
          left: '30%'
        })
      ),
      transition('open => closed', [animate('1s ease')]),
      transition('closed => open', [animate('0.25s ease')])
    ])
  ],
  templateUrl: './filters-layer.component.html',
  styleUrls: ['./filters-layer.component.scss']
})
export class FiltersLayerComponent implements OnInit {
  public filtersOpened: boolean;
  public phoneNumberFilterOpened: boolean;
  public callLengthFilterOpened: boolean;
  public universalFiltersOpened: boolean;
  public notifyShown = false;

  constructor(public contactsService: ContactsService, private store: Store<IState>) {}

  ngOnInit() {
    this.contactsService.toggleOpeningFilters.subscribe((opener: boolean) => {
      this.filtersOpened = opener;
    });
    this.contactsService.toggleOpeningPhoneNumbersFilters.subscribe(opener => {
      this.phoneNumberFilterOpened = opener;
    });
    this.contactsService.toggleOpeningCallLengthsFilters.subscribe(opener => {
      this.callLengthFilterOpened = opener;
    });
    this.contactsService.toggleOpeningUniversalFilters.subscribe(opener => {
      this.universalFiltersOpened = opener;
    });
    this.contactsService.toggleOpeningChangesNotifier.subscribe(opener => {
      this.notifyShown = opener;
    });
  }

  closeFilters() {
    if (this.filtersOpened || this.isEditingFiltersOpened()) {
      this.store.dispatch(new RevertEditedFilterChanges());
      this.store.dispatch(new RevertCallFinishTypeSnapshotAction());
    }
    this.contactsService.closeAllFilters();
    this.notifyShown = false;
  }

  isEditingFiltersOpened() {
    return this.phoneNumberFilterOpened || this.callLengthFilterOpened || this.universalFiltersOpened;
  }

  showChangesNotifier() {
    this.notifyShown = true;
  }
}
